import React from "react"
import CmsBrandHeader from "../../features/editorialContents/components/CmsBrandHeader"
import MobileOnly from "../../root/punks/mui/visibility/MobileOnly"
import CustomButton from "../../ui/atoms/Button"
import Typography from "../../ui/atoms/Typography"
import { ArrowBackIcon } from "../../ui/icons"
import { CustomDialog } from "../../ui/molecules/Dialog/CustomDialog"
import { CustomCol, CustomContainer, CustomRow } from "../../ui/spacings"
import EditorialContents from "../editorialPage/components/EditorialContents"
import BrandEditorialMenu from "./BrandEditorialMenu"

interface Props {
  brandItem?: any
  menuItems?: any[]
  contents?: any
  menuContent?: React.ReactNode
}

const BrandEditorialContainer = ({
  brandItem,
  menuItems,
  contents,
  menuContent,
}: Props) => {
  const [menuDialogOpen, setMenuDialogOpen] = React.useState(false)
  return (
    <>
      {brandItem?.data?.header?.logo?.asset && (
        <CustomContainer>
          <CmsBrandHeader item={brandItem.data} />
        </CustomContainer>
      )}
      {menuItems && (
        <CustomContainer className="mt-8">
          <MobileOnly className="mb-4">
            <CustomButton
              onClick={() => setMenuDialogOpen(true)}
              variant="outlined"
              fullWidth
            >
              DIOR MENU
            </CustomButton>
          </MobileOnly>
          <CustomRow>
            <CustomCol xs={0} sm={3}>
              <div className="mt-4 ml-4">
                <BrandEditorialMenu menuItems={menuItems ?? []} />
              </div>
            </CustomCol>
            <CustomCol xs={12} sm={9}>
              {contents && (
                <div className="my-4">
                  <EditorialContents contents={contents} />
                </div>
              )}
              {menuContent && <div className="my-4">{menuContent}</div>}
            </CustomCol>
          </CustomRow>
        </CustomContainer>
      )}
      <CustomDialog
        open={menuDialogOpen}
        onClose={() => setMenuDialogOpen(false)}
        fullWidth
        fullScreenAll
      >
        <div
          className="flex items-center justify-between pb-4"
          onClick={() => setMenuDialogOpen(false)}
          style={{ borderBottom: "1px solid #eee" }}
        >
          <ArrowBackIcon size={22} className="mr-4" />
          <Typography variant="subtitle1" uppercase weight="normal">
            DIOR MENU
          </Typography>
          <div style={{ width: 49 }}></div>
        </div>
        <div className="px-6 pt-3">
          <BrandEditorialMenu menuItems={menuItems?.slice(1) ?? []} />
        </div>
      </CustomDialog>
    </>
  )
}

export default BrandEditorialContainer
